export default __webpack_public_path__ + "static/about_team-8f2fdc00f1b53100a478be547c5605c3.webp";